var cibFlickr = ["32 32", "<path d='M0 16c0 4.099 3.323 7.417 7.422 7.417s7.422-3.318 7.422-7.417c0-4.099-3.323-7.417-7.422-7.417-4.094 0-7.422 3.318-7.422 7.417zM17.156 16c0 4.099 3.323 7.417 7.422 7.417 4.083 0 7.422-3.318 7.422-7.417s-3.323-7.417-7.417-7.417c-4.104 0-7.427 3.318-7.427 7.417z'/>"];

export { cibFlickr };

